var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lzy-img-container round-unify-xs",class:{
        'is-loaded': _vm.ready,
    },attrs:{"empty":_vm.error || !_vm.src}},[_c('img',{staticClass:"lazy-load lzy-img-loader pointer",attrs:{"src":_vm.imgSrc,"width":"auto","height":"100","ready":_vm.ready},on:{"load":function($event){return _vm.onLoad()},"error":function($event){return _vm.onError()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }